import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Typography } from '@mui/material'
import CustomTypography from 'components/Fileds/CustomTypography'
import React from 'react'
import './style.css';
import theme from 'theme/ThemeContext';
import PersonIcon from '@mui/icons-material/Person';
import CustomButton from 'components/Fileds/CustomButton';

const MergeTableContainer = ({
    open,
    onClose,
    handleCheckboxChange,
    parentTable,
    availableTables,
    handleMergeClick,
    totalCapacity,
    selectedTableIds
}) => {

  return (
    // <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <Dialog open={open} onClose={onClose} maxWidth="sm" className="merge-table-dialog-container"
        PaperProps={{
            sx: {
                borderRadius: "20px",
                backgroundColor: "white",
                width:'400px'
            },
        }}
    >
      <DialogTitle className='merge-table-title'>Merge Tables</DialogTitle>

      <DialogContent sx={{paddingBottom:'0px !important'}}>
        <Box sx={{padding:'0px 20px'}}>
            <CustomTypography variant="body1"
                label={
                    <>
                        <span style={{fontWeight:'500'}}>Main Table:</span> {parentTable?.table_no}
                    </>
                }
            />
            <CustomTypography variant="body1"
                label={
                    <>
                        <span style={{fontWeight:'500'}}>Capacity:</span> {parentTable?.capacity} Persons
                    </>
                }
            />
        </Box>

        <Divider sx={{ my: 2, borderColor:'#D9D9D9 !important' }} />

        <Box sx={{height:'200px', overflow: 'auto'}}>
            {availableTables?.map((table) => (
                // <FormControlLabel
                //     key={table.id}
                //     control={
                //         <Checkbox
                //             checked={selectedTableIds?.includes(table.id)}
                //             onChange={() => handleCheckboxChange(table)}
                //         />
                //     }
                //     label={
                //         <Box className='d-flex align-items-center justify-content-between' sx={{width:'100%'}}>
                //             <CustomTypography variant="body1" label={table?.table_no}  />
                //             <CustomTypography variant="body1" label={table?.capacity} sx={{ color: theme.palette.drawermenuitem.main }}/>
                //         </Box>
                //     }
                //     sx={{
                //         width: "100%",
                //         m: 0,
                //         px: 1,
                //     }}
                // />
                
                <Box
                    key={table.id}
                    className="d-flex align-items-center"
                    sx={{
                        px: 1,
                        width: '100%',
                    }}
                >
                    <Checkbox
                        checked={selectedTableIds?.includes(table.id)}
                        onChange={() => handleCheckboxChange(table)}
                    />
                    <Box
                        className="d-flex align-items-center justify-content-between"
                        sx={{ flexGrow: 1 }}
                    >
                        {/* Table Number */}
                        <CustomTypography variant="body1" label={table?.table_no} sx={{mb:0}}/>

                        {/* Capacity with User Icon */}
                        <Box className="d-flex align-items-center" sx={{ gap: 0.5, width:'60px' }}>
                            <PersonIcon sx={{ color: theme.palette.drawermenuitem.main }} />
                            <CustomTypography
                                variant="body1"
                                label={table?.capacity}
                                sx={{ color: theme.palette.drawermenuitem.main, mb:0 }}
                            />
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>

        <Divider sx={{ my: 2, borderColor:'#D9D9D9 !important' }} />

        <CustomTypography variant="body1" label={
            <>
               <span style={{fontWeight: 400}}>TOTAL CAPACITY: </span><span style={{ fontWeight: 500 }}>{totalCapacity}</span>
            </>
            } sx={{ color: theme.palette.drawermenuitem.main, textAlign: 'right', padding:'0px 15px', fontSize: '18px' }} 
        />
      </DialogContent>

      <DialogActions className='d-flex align-items-center' sx={{my: 2, justifyContent: 'center !important', gap:'10px'}}>
        <CustomButton
            onClick={onClose}
            sx={{
              backgroundColor:'transparent'
            }}
            variant="outlined"
            className='close-btn'
        >
            Cancel
        </CustomButton>
        <CustomButton
            disabled={selectedTableIds?.length === 0}
            onClick={handleMergeClick}
            variant="contained"
            className='confirm-btn'
            // sx={{backgroundColor:'black',color:'white'}}
        >
            Merge {selectedTableIds?.length} Tables
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}

export default MergeTableContainer
